import winningInTheUS from './winning_in_the_us.json'

export default winningInTheUS
